



// // sidebar 2 working
// import React, { useState, useEffect } from 'react';
// import { IoHomeOutline, IoChevronDown, IoChevronUp, IoMenu, IoClose, IoPersonCircleOutline } from 'react-icons/io5';
// import { TbUserCancel } from 'react-icons/tb';
// import { FaCog, FaTruck, FaBox, FaWrench, FaShoppingCart, FaWarehouse, FaChartLine, FaMoneyBill, FaBook, FaUser } from 'react-icons/fa';
// import { NavLink, useLocation } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { setSideCollapes,setPhoneToggle } from '../../redux/features/slices/modeSlice';
// import { TbReportSearch } from "react-icons/tb";
// import { useGetUserProfileQuery } from '../../redux/features/apiSlices/userApiSlice';
// import { setUserProfile } from '../../redux/features/slices/user';
// import { useGetCompanyQuery } from '../../redux/features/apiSlices/setup/company';
// import { setCompany } from '../../redux/features/slices/setup';

// import { CiSettings,CiShop  } from "react-icons/ci";
// import { AiOutlineProduct } from "react-icons/ai";
// import { HiOutlineWrenchScrewdriver,HiOutlineHomeModern  } from "react-icons/hi2";
// import { PiWarehouseLight } from "react-icons/pi";
// import { MdOutlinePayments,MdOutlineAccountBalance,MdOutlineSell   } from "react-icons/md";





// // Link arrays (unchanged)
// const links = [
//   { id: 1, text: 'Dashboard', icon: <IoHomeOutline size={20} />, path: "/" },
//    { id: 2, text: 'pos', icon: <TbUserCancel size={20} />, path: '/pos' }
//   // { id: 2, text: 'Complaint', icon: <TbUserCancel size={20} />, path: '/complaints' }
// ];

// const settings = [
//   // { id: 1, text: 'Settings', path: "/settings" },
//   // { id: 2, text: 'Change Password', path: '/changepassword' },
//   // { id: 4, text: 'Country', path: '/country' },
//   // { id: 5, text: 'Region', path: '/region' },
//   // { id: 6, text: 'City', path: '/city' },
//   // { id: 7, text: 'Financial Year', path: '/financialyear' },
//   // { id: 8, text: 'Query', path: '/query' },
//   { id: 1, text: 'Users', path: '/users' },
//   { id: 2, text: 'Register', path: "/register" },
//   { id: 3, text: 'role & permissions', path: "/role-permission" },
//   { id: 4, text: 'Company Setup', path: "/company-setup" },
//     { id: 5, text: 'payment method', path: "/payment-method" },




// ];
// const reports = [
//   { id: 1, text: 'load sheet', path: "/loadsheet" },
//   { id: 2, text: 'sale & purchase', path: "/sale-n-purchase" },
//   { id: 3, text: 'stock ledger', path: "/stockledger" },
//   { id: 4, text: 'customer report', path: "/customerreport" },
//   { id: 5, text: 'item list', path: "/itemlist" },
//   { id: 6, text: 'last purchase / sale', path: "/last-purchase-sale" },
//   { id: 7, text: 'daily stock', path: "/daily-stock" },
//   { id: 8, text: 'product wise sale', path: "/product-wise-sale" },
//   { id: 9, text: 'stock position', path: "/stock-position" },
//   { id: 10, text: 'gross profit', path: "/gross-profit-report" },
//   { id: 11, text: 'all sale invoices', path: "/all-sale-invoices" },
//   { id: 12, text: 'yearly expenses', path: "/yearly-expenses" },
//   { id: 13, text: 'max sale product', path: "/max-sale-product" },
//   { id: 14, text: 'unsold products', path: "/unsold-products" },
//   { id: 15, text: 'daily sales', path: "/daily-sales" },
//   { id: 16, text: 'aging receivable', path: "/aging-receiveable" },
//   { id: 17, text: 'aging payable', path: "/aging-payable" },
//   { id: 18, text: 'account ledger', path: "/account-ledger" },
//   { id: 19, text: 'outstanding report', path: "/outstanding-report" },
//   { id: 20, text: 'PDC Report', path: "/pdc-report" },
//   { id: 21, text: 'daily Trans Report', path: "/transaction-report" },
//   { id: 22, text: 'Trial Balance', path: "/trial-balance" },

// ];

// const distribution = [
//   // { id: 1, text: 'Builty Form', path: "/builtyform" },
//   { id: 1, text: 'Order Booking', path: "/orderbooking" },
//   // { id: 3, text: 'Load Summary', path: "/loadsummary" },
//   { id: 2, text: 'Orders', path: "/orders" },
//   { id: 3, text: 'Orders Return', path: "/order-return" },
//   { id: 4, text: 'Order Return View', path: "/order-return-view" },
//   { id: 5, text: 'Sale Invoice', path: "/sale-invoice" },
//   { id: 6, text: 'Sale Invoice View', path: "/sale-invoice-view" },
//   { id: 7, text: 'quotation', path: "/quotation" },
//   { id: 8, text: 'quotation view', path: "/quotation-view" },
//   { id: 9, text: 'delivery chalan', path: "/delivery-chalan" },

// ];

// const productLinks = [
//   { id: 1, text: 'Product Type', path: "/product-type" },
//   { id: 2, text: 'Brand', path: "/add-brand" },
//   { id: 3, text: 'Category', path: "/add-category" },
//   { id: 4, text: 'Sub Category', path: "/add-subcategory" },
//   { id: 5, text: 'Unit', path: "/add-unit" },
//   { id: 6, text: 'New Product', path: "/add-product" },
//   { id: 7, text: 'Product', path: "/product" },
//   // { id: 8, text: 'Scan Product', path: "/scan" },
//   { id: 8, text: 'Pack Type', path: "/packtype" },
// ];

// const setupLinks = [
//   { id: 1, text: 'Vendor', path: "/vendor" },
//   { id: 2, text: 'Warehouse', path: "/warehouse" },
//   { id: 3, text: 'Customers', path: "/customers" },
//   { id: 4, text: 'Staff Category', path: "/staff-category" },
//   { id: 5, text: 'Add Staff', path: "/add-staff" },
//   { id: 6, text: 'Staffs View', path: "/staff-view" },
//   { id: 7, text: 'Staff Category View', path: "/staff-view-category" },
//   { id: 8, text: 'Vendor View', path: "/vendor-view" },
//   { id: 9, text: 'Customer Category', path: "/add-customer-category" },
//   { id: 10, text: 'Customer Category View', path: "/customer-view-category" },
//   { id: 11, text: 'Add Town', path: "/add-town" },
//   { id: 12, text: 'Town View', path: "/town-view" },
//   { id: 13, text: 'Warehouse View', path: "/warehouse-view" },
//   { id: 14, text: 'Add Zone', path: "/add-zone" },
//   { id: 15, text: 'Zone View', path: "/zone-view" },
//   { id: 16, text: 'Add Saleman', path: "/add-saleman" },
//   { id: 17, text: 'Saleman View', path: "/saleman-view" },
//   { id: 18, text: 'Customers View', path: "/customers-view" },
//   { id: 19, text: 'Add Patty Category', path: "/add-patty-category" },
//   { id: 20, text: 'Patty Category View', path: "/patty-category-view" },
//   { id: 21, text: 'GST Type', path: "/gst-type" },
//   { id: 22, text: 'Schedule Type', path: "/schedule-type" },
//   { id: 23, text: 'Advance Tax', path: "/advance-tax" },
//   { id: 24, text: 'Invoice No Gen', path: "/invoice-no-gen" }
// ];

// const purchaseLinks = [
//   { id: 1, text: 'Purchase Order', path: "/purchase-order" },
//   { id: 2, text: 'Add Purchase', path: "/add-purchase" },
//   { id: 3, text: 'Purchase Invoice', path: "/purchase-invoice" },
//   { id: 4, text: 'Purchase Return', path: "/purchase-return" },
//   { id: 5, text: 'Purchase Return View', path: "/purchase-return-view" },
//   { id: 6, text: 'Purchase Orders View', path: "/purchase-orders-view" },
//   { id: 7, text: 'Purchase Invoice View', path: "/purchase-invoice-view" }
// ];

// const inventoryLinks = [
//   { id: 1, text: 'Inventory', path: "/get-inventory" }
// ];

// const stockLinks = [
//   { id: 1, text: 'Stock Value', path: "/stockvalue" },
//   { id: 2, text: 'Stock Adjustment', path: "/stockadjustment" },
// ];

// const paymentsLink = [
//   { id: 1, text: 'Purchase Payments', path: "/payment-voucher" },
//   { id: 2, text: 'Receive Payment', path: "/recieve-voucher" },
//   { id: 3, text: 'Journal Payment', path: "/journal-payment" },
//   { id: 4, text: 'Journal Payment View', path: "/journal-payment-view" },
//   { id: 5, text: 'Patty Payment', path: "/patty-payment" },
//   { id: 6, text: 'Patty Payment View', path: "/patty-payment-view" },
//   { id: 7, text: 'Receive Payment View', path: "/receive-payment-view" },
//   { id: 8, text: 'Purchase Payment View', path: "/purchase-payment-view" },
// ];

// const accounts = [
//   { id: 1, text: 'Chart of Accounts', path: "/chart-of-accounts" },
// ];
// // const user = [
// //   { id: 1, text: 'Login', path: "/login" },

// // ];

// const Sidebar = () => {
//   const [isOpen, setIsOpen] = useState(false); // Mobile toggle
//   const { sideBarCollapes } = useSelector((state) => state.mode);
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const [openDropdown, setOpenDropdown] = useState(null);

//   const { data: company } = useGetCompanyQuery();
//   useEffect(() => {
//     if (company) {
//       dispatch(setCompany(company));
//     }
//   }, [company, dispatch]);



//   // Map sections to their links for active route checking
//   const sections = {
//     main: links,
//     settings: settings,
//     distribution: distribution,
//     products: productLinks,
//     reports: reports,
//     setup: setupLinks,
//     purchase: purchaseLinks,
//     inventory: inventoryLinks,
//     stock: stockLinks,
//     payments: paymentsLink,
//     accounts: accounts,
//     // user: user,
//   };

//   // Set initial open dropdown based on active route
//   useEffect(() => {
//     const currentPath = location.pathname;
//     const activeSection = Object.keys(sections).find((section) =>
//       sections[section].some((link) => link.path === currentPath)
//     );
//     setOpenDropdown(activeSection || null);
//   }, [location.pathname]);

//         const { data: user, isLoading, error } = useGetUserProfileQuery();
//   useEffect(() => {
//     if (user) {
//       dispatch(setUserProfile(user));
//     }
//   }, [user, dispatch]);


//   const toggleSidebar = () => setIsOpen(!isOpen);


//   const togglePhoneSidebar = () => {
//     setIsOpen(!isOpen);
//     dispatch(setPhoneToggle())
//   }

//   const toggleDropdown = (section) => {
//     if (sideBarCollapes === 'hide' && window.innerWidth >= 768) {
//       dispatch(setSideCollapes('show')); // Expand sidebar on headmenu click in collapsed mode
//     }
//     setOpenDropdown(openDropdown === section ? null : section);
//   };

//   const sectionIcons = {
//     main: <HiOutlineHomeModern  size={20} />,
//     settings: <CiSettings size={20} />,
//     distribution: <MdOutlineSell  size={20} />,
//     products: <AiOutlineProduct  size={20} />,
//     reports: <TbReportSearch size={20} />,
//     setup: <HiOutlineWrenchScrewdriver size={20} />,
//     purchase: <CiShop  size={20} />,
//     inventory: <PiWarehouseLight size={20} />,
//     stock: <FaChartLine size={20} />,
//     payments: <MdOutlinePayments size={20} />,
//     accounts: <MdOutlineAccountBalance  size={20} />,
//     // user: <FaUser size={20} />,
//   };

//   const renderLinks = (linksArray, sectionTitle, sectionKey) => {
//     const isSectionActive = linksArray.some(
//       (link) => link.path === location.pathname
//     );



//     return (
//       <div className="mb-2 relative transition-all duration-300 ease-in-out">
//         <button
//           onClick={() => toggleDropdown(sectionKey)}
//           className={`flex items-center w-full p-2 transition-all  duration-300 ease-in-out hover:bg-opacity-90 hover:bg-blue-600 hover:text-white  text-sm
//             ${isSectionActive ? 'bg-blue-100 border-l-4 border-blue-700 text-blue-700 font-semibold' : ''}
//             ${sideBarCollapes === 'hide' && !isOpen ? 'justify-center' : 'justify-between'}`}
//         >
//           <div className="flex items-center">
//             <span className={sideBarCollapes === 'hide' && !isOpen ? '' : 'mr-2'}>{sectionIcons[sectionKey]}</span>
//             {(sideBarCollapes !== 'hide' || isOpen) && <span>{sectionTitle}</span>}
//           </div>
//           {(sideBarCollapes !== 'hide' || isOpen) && (
//             <span>{openDropdown === sectionKey ? <IoChevronUp size={16} /> : <IoChevronDown size={16} />}</span>
//           )}
//         </button>
//         <ul
//           className={`transition-all duration-300 ease-in-out overflow-y-auto
//             ${sideBarCollapes === 'hide' && !isOpen
//               ? `absolute left-full top-0 ml-1 bg-white w-56 rounded-lg shadow-lg z-50
//                 ${openDropdown === sectionKey
//                   ? 'opacity-100 translate-x-0'
//                   : 'opacity-0 translate-x-2 pointer-events-none'}`
//               : openDropdown === sectionKey
//               ? 'max-h-96 pl-4 opacity-100'
//               : 'max-h-0 opacity-0'
//             }`}
//         >
//           {linksArray.map((link) => (
//             <li key={link.id}>
//               <NavLink
//                 to={link.path}
//                 className={({ isActive }) =>
//                   `flex my-2 items-center p-2  me-4 text-gray-800 transition-all duration-300 ease-in-out hover:bg-blue-600 hover:text-white rounded-md text-sm
//                   ${isActive ? 'bg-blue-100 text-blue-600 ' : ''}`
//                 }
//                 onClick={() => {
//                   setOpenDropdown(sectionKey);
//                   if (isOpen) setIsOpen(false);
//                 }}
//               >
//                 {link.icon && <span className="mr-2">{link.icon}</span>}
//                 <span>{link.text}</span>
//               </NavLink>
//             </li>
//           ))}
//         </ul>
//       </div>
//     );
//   };

//   return (
//     <>
//       {/* Mobile Toggle Button */}
//      {isOpen ? (
//        <button
//         className="md:hidden fixed top-4 left-36 z-50 text-gray-800 p-2 rounded-full"
//         onClick={togglePhoneSidebar}
//       >
//         <IoClose size={20} /> 
//       </button>
//      ):(
//        <button
//         className="md:hidden fixed top-4 left-5 z-50 text-gray-800 p-2 rounded-full"
//         onClick={togglePhoneSidebar}
//       >
//         <IoMenu size={20} />
//       </button>
//      )}

//       {/* Sidebar */}
//       <div
//         className={`h-screen bg-white  text-gray-800 transition-all duration-300 z-40
//           ${isOpen ? 'translate-x-0' : '-translate-x-full'}
//           md:static md:translate-x-0
//           ${isOpen ? 'w-56' : sideBarCollapes === 'hide' ? 'w-20' : 'w-56'}
//           flex flex-col shadow-lg`}
//       >
//         <div className="logo my-2">
//           <div className={`flex items-center relative px-4 h-[4rem] border-b-[1px] border-gray-300`}>
//             <span className="text-5xl italic text-sky-700">X</span>
//             <div className={`${sideBarCollapes === 'hide' && !isOpen ? 'hidden' : 'flex'} flex-col gap-0`}>
//               <span className="text-xl absolute top-5 left-10 text-gray-800 font-bold">enith</span>
//               <span className="text-md absolute top-9 text-gray-800">servics</span>
//             </div>
//           </div>
//         </div>

//         {/* Navigation Links */}
//         <nav className="flex-1  overflow-y-auto transition-all duration-300 ease-in-out">
//           {renderLinks(links, 'Main', 'main')}
//           {renderLinks(settings, 'Settings', 'settings')}
//           {renderLinks(distribution, 'Distribution', 'distribution')}
//           {renderLinks(productLinks, 'Products', 'products')}
//           {renderLinks(setupLinks, 'Setup', 'setup')}
//           {renderLinks(purchaseLinks, 'Purchase', 'purchase')}
//           {renderLinks(inventoryLinks, 'Inventory', 'inventory')}
//           {renderLinks(stockLinks, 'Stock', 'stock')}
//           {renderLinks(paymentsLink, 'Payments', 'payments')}
//           {renderLinks(accounts, 'Accounts', 'accounts')}
//           {/* {renderLinks(user, 'User', 'user')} */}
//           {renderLinks(reports, 'Reports', 'reports')}
//         </nav>

//         {/* Profile Section */}
//         <div className="p-4 border-t border-gray-300">
//           <div className="flex items-center">
//             <IoPersonCircleOutline size={28} className={sideBarCollapes === 'hide' && !isOpen ? '' : 'mr-2'} />
//             {(sideBarCollapes !== 'hide' || isOpen) && (
//               <div className="min-w-0">
//                 <p className="text-sm font-medium truncate">{user?.username || 'Admin User'}</p>
//                 <p className="text-xs text-gray-500 truncate">{user?.email || 'admin@example.com'}</p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Mobile Overlay */}
//       {isOpen && (
//         <div
//           className="fixed left-56 inset-0 bg-black bg-opacity-50 md:hidden"
//           onClick={togglePhoneSidebar}
//         />
//       )}
//     </>
//   );
// };

// export default Sidebar;


import React, { useState, useEffect } from 'react';
import {
  IoHomeOutline,
  IoChevronDown,
  IoChevronUp,
  IoMenu,
  IoClose,
  IoPersonCircleOutline,
} from 'react-icons/io5';
import { TbUserCancel } from 'react-icons/tb';
import {
  FaCog,
  FaTruck,
  FaBox,
  FaWrench,
  FaShoppingCart,
  FaWarehouse,
  FaChartLine,
  FaMoneyBill,
  FaBook,
} from 'react-icons/fa';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setSideCollapes, setPhoneToggle } from '../../redux/features/slices/modeSlice';
import { TbReportSearch } from 'react-icons/tb';
import { useGetUserProfileQuery } from '../../redux/features/apiSlices/userApiSlice';
import { setUserProfile } from '../../redux/features/slices/user';
import { useGetCompanyQuery } from '../../redux/features/apiSlices/setup/company';
import { setCompany } from '../../redux/features/slices/setup';
import { Drawer } from 'antd';

import { CiSettings, CiShop } from "react-icons/ci";
import { AiOutlineProduct } from "react-icons/ai";
import { HiOutlineWrenchScrewdriver, HiOutlineHomeModern } from "react-icons/hi2";
import { PiWarehouseLight } from "react-icons/pi";
import { MdOutlinePayments, MdOutlineAccountBalance, MdOutlineSell } from "react-icons/md";

// Link arrays
const links = [
  { id: 1, text: 'Dashboard', icon: <IoHomeOutline size={20} />, path: "/" },
  { id: 2, text: 'pos', icon: <TbUserCancel size={20} />, path: '/pos' },
  { id: 3, text: 'sale invoice view', icon: <TbUserCancel size={20} />, path: '/sale-invoice-view' },
  { id: 4, text: 'Sale Return', icon: <TbUserCancel size={20} />, path: '/sale-return' },
  { id: 8, text: 'sale return view', icon: <TbUserCancel size={20} />, path: '/sale-return-view' },
  { id: 5, text: 'quotation', icon: <TbUserCancel size={20} />, path: '/quotation' },
  { id: 6, text: 'quotation view', icon: <TbUserCancel size={20} />, path: '/quotation-view' },
  { id: 7, text: 'Pending FBR Invoices', icon: <TbUserCancel size={20} />, path: '/pending-fbr-invoices' },

];

const settings = [
  { id: 1, text: 'Users', path: '/users' },
  { id: 2, text: 'Register', path: "/register" },
  { id: 3, text: 'role & permissions', path: "/role-permission" },
  { id: 4, text: 'Company Setup', path: "/company-setup" },
  { id: 4, text: 'company view', path: "/company-view" },
  { id: 5, text: 'payment method', path: "/payment-method" },
  { id: 6, text: 'payment view', path: "/payment-view" },
  { id: 7, text: 'barcode generator', path: "/barcode-generator" },
  { id: 8, text: 'product viewer', path: "/product-viewer" },
];

const reports = [
  { id: 1, text: 'load sheet', path: "/loadsheet" },
  { id: 2, text: 'sale & purchase', path: "/sale-n-purchase" },
  { id: 3, text: 'stock ledger', path: "/stockledger" },
  { id: 4, text: 'customer report', path: "/customerreport" },
  { id: 5, text: 'item list', path: "/itemlist" },
  { id: 6, text: 'last purchase / sale', path: "/last-purchase-sale" },
  { id: 7, text: 'daily stock', path: "/daily-stock" },
  { id: 8, text: 'product wise sale', path: "/product-wise-sale" },
  { id: 9, text: 'stock position', path: "/stock-position" },
  { id: 10, text: 'gross profit', path: "/gross-profit-report" },
  { id: 11, text: 'all sale invoices', path: "/all-sale-invoices" },
  { id: 12, text: 'yearly expenses', path: "/yearly-expenses" },
  { id: 13, text: 'max sale product', path: "/max-sale-product" },
  { id: 14, text: 'unsold products', path: "/unsold-products" },
  { id: 15, text: 'daily sales', path: "/daily-sales" },
  { id: 16, text: 'aging receivable', path: "/aging-receiveable" },
  { id: 17, text: 'aging payable', path: "/aging-payable" },
  { id: 18, text: 'account ledger', path: "/account-ledger" },
  { id: 19, text: 'outstanding report', path: "/outstanding-report" },
  { id: 20, text: 'PDC Report', path: "/pdc-report" },
  { id: 21, text: 'daily Trans Report', path: "/transaction-report" },
  { id: 22, text: 'Trial Balance', path: "/trial-balance" },
  { id: 23, text: 'Stock Ledger Summary', path: "/stock-ledger-summary" },
];

const productLinks = [
  { id: 1, text: 'Product Type', path: "/product-type" },
  { id: 2, text: 'Brand', path: "/add-brand" },
  { id: 3, text: 'Category', path: "/add-category" },
  { id: 4, text: 'Sub Category', path: "/add-subcategory" },
  { id: 5, text: 'Unit', path: "/add-unit" },
  { id: 6, text: 'New Product', path: "/add-product" },
  { id: 7, text: 'Product', path: "/product" },
  { id: 8, text: 'Pack Type', path: "/packtype" },
];

const setupLinks = [
  { id: 1, text: 'Vendor', path: "/vendor" },
  { id: 2, text: 'Warehouse', path: "/warehouse" },
  { id: 3, text: 'Customers', path: "/customers" },
  { id: 8, text: 'Vendor View', path: "/vendor-view" },
  { id: 9, text: 'Customer Category', path: "/add-customer-category" },
  { id: 10, text: 'Customer Category View', path: "/customer-view-category" },
  { id: 11, text: 'Add Town', path: "/add-town" },
  { id: 12, text: 'Town View', path: "/town-view" },
  { id: 13, text: 'Warehouse View', path: "/warehouse-view" },
  { id: 16, text: 'Add Saleman', path: "/add-saleman" },
  { id: 17, text: 'Saleman View', path: "/saleman-view" },
  { id: 18, text: 'Customers View', path: "/customers-view" },
  { id: 19, text: 'Add Patty Category', path: "/add-patty-category" },
  { id: 20, text: 'Patty Category View', path: "/patty-category-view" },
  { id: 21, text: 'GST Type', path: "/gst-type" },
  { id: 22, text: 'Schedule Type', path: "/schedule-type" },
  { id: 23, text: 'Advance Tax', path: "/advance-tax" },
  { id: 24, text: 'Add Device', path: "/add-device" },
];

const purchaseLinks = [
  { id: 1, text: 'Purchase Order', path: "/purchase-order" },
  { id: 2, text: 'Add Purchase', path: "/add-purchase" },
  { id: 3, text: 'Purchase Invoice', path: "/purchase-invoice" },
  { id: 4, text: 'Purchase Return', path: "/purchase-return" },
  { id: 5, text: 'Purchase Return View', path: "/purchase-return-view" },
  { id: 6, text: 'Purchase Orders View', path: "/purchase-orders-view" },
  { id: 7, text: 'Purchase Invoice View', path: "/purchase-invoice-view" }
];

const inventoryLinks = [
  { id: 1, text: 'Inventory', path: "/get-inventory" }
];

const stockLinks = [
  { id: 1, text: 'Stock Value', path: "/stockvalue" },
  { id: 2, text: 'Stock Adjustment', path: "/stockadjustment" },
];

const paymentsLink = [
  { id: 1, text: 'Purchase Payments', path: "/payment-voucher" },
  { id: 2, text: 'Receive Payment', path: "/recieve-voucher" },
  { id: 3, text: 'Journal Payment', path: "/journal-payment" },
  { id: 4, text: 'Journal Payment View', path: "/journal-payment-view" },
  { id: 5, text: 'Patty Payment', path: "/patty-payment" },
  { id: 6, text: 'Patty Payment View', path: "/patty-payment-view" },
  { id: 7, text: 'Receive Payment View', path: "/receive-payment-view" },
  { id: 8, text: 'Purchase Payment View', path: "/purchase-payment-view" },
];

const accounts = [
  { id: 1, text: 'Chart of Accounts', path: "/chart-of-accounts" },
];

// Export sections at the top level
export const sections = {
  main: links,
  settings: settings,
  products: productLinks,
  reports: reports,
  setup: setupLinks,
  purchase: purchaseLinks,
  inventory: inventoryLinks,
  stock: stockLinks,
  payments: paymentsLink,
  accounts: accounts,
};

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false); // Mobile toggle
  const { sideBarCollapes } = useSelector((state) => state.mode);
  const { user: userProfile } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState(null);

  const { data: user, isLoading, error } = useGetUserProfileQuery();
  const { data: company } = useGetCompanyQuery();

  useEffect(() => {
    if (user) {
      dispatch(setUserProfile(user));
    }
  }, [user, dispatch]);

  useEffect(() => {
    if (company) {
      dispatch(setCompany(company));
    }
  }, [company, dispatch]);

  // Get user permissions
  const permissions = userProfile?.roleAndPermission?.permissions || [];

  // Normalize text for comparison
  const normalizeText = (text) => {
    if (!text || typeof text !== 'string') return '';
    return text.toLowerCase().replace(/\s+/g, '');
  };

  // Filter links based on user permissions using text property
  const filterLinks = (linksArray) => {
    if (!permissions || permissions.length === 0 || !linksArray) {
      return [];
    }
    return linksArray.filter((link) => {
      if (!link || !link.text) return false;
      return permissions.some(
        (perm) => perm && normalizeText(perm) === normalizeText(link.text)
      );
    });
  };

  // Get all permitted paths
  const getPermittedPaths = () => {
    if (!permissions || permissions.length === 0) {
      return [];
    }
    const allLinks = Object.values(sections).flat();
    return allLinks
      .filter((link) => {
        if (!link || !link.text) return false;
        return permissions.some(
          (perm) => perm && normalizeText(perm) === normalizeText(link.text)
        );
      })
      .map((link) => link.path);
  };

  // Check if current path is allowed, redirect if not
  useEffect(() => {
    if (isLoading || !userProfile) return;
    const permittedPaths = getPermittedPaths();
    const currentPath = location.pathname;

    // Check if the current path exactly matches or is a sub-path of an allowed route
    const isPathAllowed = permittedPaths.some(path => {
      if (path === '/') return currentPath === '/';
      const normalizedPath = path.endsWith('/') ? path.slice(0, -1) : path;
      const normalizedCurrent = currentPath.endsWith('/') ? currentPath.slice(0, -1) : currentPath;
      return normalizedCurrent === normalizedPath || normalizedCurrent.startsWith(`${normalizedPath}/`);
    });

    if (!isPathAllowed && currentPath !== '/not-authorized' && currentPath !== '/') {
      navigate('/not-authorized');
    }
  }, [location.pathname, userProfile, isLoading, navigate]);

  // Set initial open dropdown based on active route
  useEffect(() => {
    if (!userProfile) return;
    const currentPath = location.pathname;
    const activeSection = Object.keys(sections).find((section) => {
      const filteredLinks = filterLinks(sections[section]);
      return filteredLinks.some((link) => link.path === currentPath);
    });
    setOpenDropdown(activeSection || null);
  }, [location.pathname, userProfile]);

  const togglePhoneSidebar = () => {
    setIsOpen(!isOpen);
    dispatch(setPhoneToggle());
  };

  const toggleDropdown = (section) => {
    if (sideBarCollapes === 'hide' && window.innerWidth >= 768) {
      dispatch(setSideCollapes('show'));
    }
    setOpenDropdown(openDropdown === section ? null : section);
  };

  const sectionIcons = {
    main: <HiOutlineHomeModern size={20} />,
    settings: <CiSettings size={20} />,
    products: <AiOutlineProduct size={20} />,
    reports: <TbReportSearch size={20} />,
    setup: <HiOutlineWrenchScrewdriver size={20} />,
    purchase: <CiShop size={20} />,
    inventory: <PiWarehouseLight size={20} />,
    stock: <FaChartLine size={20} />,
    payments: <MdOutlinePayments size={20} />,
    accounts: <MdOutlineAccountBalance size={20} />,
  };

  const renderLinks = (linksArray, sectionTitle, sectionKey) => {
    // Filter submenu links based on permissions
    const filteredLinks = filterLinks(linksArray);

    // Only render the section if it has permitted links
    if (filteredLinks.length === 0) {
      return null;
    }

    return (
      <div className="mb-2 relative transition-all duration-300 ease-in-out">
        <button
          onClick={() => toggleDropdown(sectionKey)}
          className={`flex items-center w-full p-3 text-gray-800 hover:bg-blue-400 text-sm transition-colors
            ${filteredLinks.some((link) => link.path === location.pathname) ? 'bg-blue-600 text-white' : ''}
            ${sideBarCollapes === 'hide' && !isOpen ? 'justify-center' : 'justify-between'}`}
        >
          <div className="flex items-center">
            <span className={sideBarCollapes === 'hide' && !isOpen ? '' : 'mr-3'}>{sectionIcons[sectionKey]}</span>
            {(sideBarCollapes !== 'hide' || isOpen) && <span className="font-medium">{sectionTitle}</span>}
          </div>
          {(sideBarCollapes !== 'hide' || isOpen) && (
            <span>{openDropdown === sectionKey ? <IoChevronUp size={16} /> : <IoChevronDown size={16} />}</span>
          )}
        </button>
        <ul
          className={`transition-all duration-300 ease-in-out
            ${sideBarCollapes === 'hide' && !isOpen
              ? `absolute left-full top-0 ml-1 bg-white w-56 shadow-lg z-50 max-h-80 overflow-y-auto
                ${openDropdown === sectionKey
                ? 'opacity-100 translate-x-0'
                : 'opacity-0 translate-x-2 pointer-events-none'}`
              : openDropdown === sectionKey
                ? 'max-h-80 pl-4 opacity-100 overflow-y-auto'
                : 'max-h-0 opacity-0 overflow-hidden'
            }`}
        >
          {filteredLinks.map((link) => (
            <li key={link.id} className="mb-1">
              <NavLink
                to={link.path}
                className={({ isActive }) =>
                  `flex items-center p-3 text-gray-800 hover:bg-blue-50 text-sm transition-colors
                  ${isActive ? 'bg-blue-100 border-l-4 border-blue-500' : ''}`
                }
                onClick={() => {
                  setOpenDropdown(sectionKey);
                  if (isOpen) setIsOpen(false);
                }}
              >
                {link.icon && <span className="mr-3">{link.icon}</span>}
                <span>{link.text}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const coll = sideBarCollapes === 'hide';

  const logo = (
    <div className="logo my-2 flex items-center justify-center">
      <div className={`flex  justify-center items-center relative px-4 h-[4rem] border-b-[1px] border-gray-300`}>
        <span className={`text-5xl ${coll && !isOpen ? 'block text-center' : 'hidden'} italic text-sky-700`}>X</span>
        <div className={`${coll && !isOpen ? 'hidden' : 'flex'} flex-col gap-0`}>
          <img src={`${process.env.REACT_APP_BASE_URL}/${company?.logo}`} className='w-20' />
        </div>
      </div>
    </div>
  );

  const profile = (
    <div className="p-4 border-t border-gray-300">
      <div className="flex items-center">
        <IoPersonCircleOutline size={28} className={coll && !isOpen ? '' : 'mr-2'} />
        {(!coll || isOpen) && (
          <div className="min-w-0">
            <p className="text-sm font-medium truncate">{userProfile?.username || 'Admin User'}</p>
            <p className="text-xs text-gray-500 truncate">{userProfile?.email || 'admin@example.com'}</p>
          </div>
        )}
      </div>
    </div>
  );

  const sidebarContent = (
    <div className="h-full flex flex-col">
      {logo}
      <div className="flex-1 overflow-y-auto px-2">
        <nav className="transition-all duration-300 ease-in-out">
          {renderLinks(sections.main, 'Main', 'main')}
          {renderLinks(sections.settings, 'Settings', 'settings')}
          {renderLinks(sections.products, 'Products', 'products')}
          {renderLinks(sections.setup, 'Setup', 'setup')}
          {renderLinks(sections.purchase, 'Purchase', 'purchase')}
          {renderLinks(sections.inventory, 'Inventory', 'inventory')}
          {renderLinks(sections.stock, 'Stock', 'stock')}
          {renderLinks(sections.payments, 'Payments', 'payments')}
          {renderLinks(sections.accounts, 'Accounts', 'accounts')}
          {renderLinks(sections.reports, 'Reports', 'reports')}
        </nav>
      </div>
      {profile}
    </div>
  );

  return (
    <>
      {/* Mobile Toggle Button */}
      {isOpen ? (
        <button
          className="md:hidden fixed top-4 left-36 z-50 text-gray-800 p-2 bg-white rounded-full shadow-lg"
          onClick={togglePhoneSidebar}
        >
          <IoClose size={20} />
        </button>
      ) : (
        <button
          className="md:hidden fixed top-4 left-5 z-50 text-gray-800 p-2 bg-white rounded-full shadow-lg"
          onClick={togglePhoneSidebar}
        >
          <IoMenu size={20} />
        </button>
      )}

      {/* Desktop Sidebar */}
      <div
        className={`h-screen bg-white text-gray-800 transition-all duration-300 z-40 hidden md:block shadow-lg
          ${sideBarCollapes === 'hide' ? 'w-20' : 'w-56'}`}
      >
        {sidebarContent}
      </div>

      {/* Mobile Drawer */}
      <Drawer
        placement="left"
        closable={false}
        onClose={togglePhoneSidebar}
        open={isOpen}
        width={224}
        styles={{
          body: { padding: 0, background: 'white', height: '100%', overflow: 'hidden' },
          header: { display: 'none' }
        }}
        className="md:hidden"
      >
        {sidebarContent}
      </Drawer>
    </>
  );
};

export default Sidebar;
